import React from "react";
import { Layout, Typography, Card, Row, Col } from "antd";
import { ApiOutlined, CloudSyncOutlined, DatabaseOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const integrations = [
    { 
        id: 1, 
        title: "API Integrations", 
        description: "Seamlessly connect your applications with JectHub's powerful APIs.",
        icon: <ApiOutlined style={{ fontSize: '32px', color: '#1890ff' }} />
    },
    { 
        id: 2, 
        title: "Cloud Sync", 
        description: "Synchronize your AI models and datasets with cloud platforms effortlessly.",
        icon: <CloudSyncOutlined style={{ fontSize: '32px', color: '#52c41a' }} />
    },
    { 
        id: 3, 
        title: "Database Connectivity", 
        description: "Integrate with various databases to enhance data accessibility and processing.",
        icon: <DatabaseOutlined style={{ fontSize: '32px', color: '#fa8c16' }} />
    }
];

const Integrations = () => {
    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Integrations</Title>
                <Paragraph>Enhance your experience with JectHub by integrating with a variety of platforms and services.</Paragraph>
                
                <Row gutter={[16, 16]}>
                    {integrations.map((integration) => (
                        <Col xs={24} sm={12} md={8} key={integration.id}>
                            <Card hoverable>
                                {integration.icon}
                                <Title level={4}>{integration.title}</Title>
                                <Paragraph>{integration.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
};

export default Integrations;
